import { Component } from "react";
import "./SimilarProducts.css";
import { SmallProduct } from "../smallproduct/SmallProduct";
import axios from "axios";
import { translateUI } from "../../util/dataTranslation";

export class SimilarProducts extends Component {
  constructor() {
    super();
    this.state = {
      similar_products_arr: [],
	  limit: 50
    };
  }

  componentDidMount() {
    this.loadSimilarProducts(this.props);
  }

  loadSimilarProducts = (nextProps) => {
    if (this.props.categoryId && nextProps.productName) {
      var productNameSubStr = nextProps.productName.split(" ", 3);

      var mainThis = this;
      axios
        .post(window.ajaxLink + "products/getSimilarProducts", {
          category_id: nextProps.categoryId,
          search_query: productNameSubStr,
          product_id: nextProps.productId,
          limit: nextProps.doLimit ? nextProps.doLimit : 24,
        })
        .then((res) => {
          mainThis.setState({
            similar_products_arr: res["data"]["responseData"]["similarProductsList"],
			limit: nextProps.doLimit ? nextProps.doLimit : 50
          });
        })
        .catch((err) => {});
    }
  };

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    this.loadSimilarProducts(nextProps);
  };

  render() {
    return (
      <>
        {this.state.similar_products_arr.length > 0 && (
          <div className="similar_products">
            <h2 className="similar_products_title">{translateUI("Slični proizvodi", this.props.currentLanguage)}</h2>
            <div className="similar_products_container">
              {this.state.similar_products_arr.length > 0 &&
                this.state.similar_products_arr.slice(0, this.state.limit).map((oneItem, i) => (
                  <SmallProduct key={i} oneItem={oneItem} similarItem={true} currentLanguage={this.props.currentLanguage} />
                ))}
            </div>
          </div>
        )}
      </>
    );
  }
}

export default SimilarProducts;
